angular
  .module('shared.filters', [])
  /**
   * Filter used to strip the component type prefix from a backup path.
   *
   * @param {String} input - The source path.
   * @returns {String} - The result path.
   */
  .filter('stripType', () => {
    let stripTypeFilter = (input) => {
      var slashIndex = input ? input.indexOf('/') : -1;
      return slashIndex >= 0 ? input.substring(slashIndex + 1) : input;
    };

    return stripTypeFilter;
  });
